import React from "react";
import MainContainer from "../../components/container/MainContainer";
import TransactionGridContainer from "../../components/container/TransactionGridContainer";
import TransactionGridItem from "../../components/container/TransactionGridItem";
import {
  CodeSquare,
  EarthLock,
  Landmark,
  Package,
  WalletCards,
} from "lucide-react";

const Setting = () => {
  return (
    <MainContainer>
      <div>
        <h3 className="text-text-1/80">Settings</h3>

        <TransactionGridContainer title="Countries, Regions & Communities">
          <TransactionGridItem
            component={WalletCards}
            title="Communities"
            link="/communities"
          />
          <TransactionGridItem
            component={Package}
            title="Countries"
            link="/settings/nations"
          />
          <TransactionGridItem
            component={CodeSquare}
            title="Departments"
            link="/settings/departments"
          />
        </TransactionGridContainer>

        <TransactionGridContainer title="Users, Roles, Countries & Donors">
          <TransactionGridItem
            component={Landmark}
            title="Users"
            link="/users"
          />
          <TransactionGridItem
            component={Package}
            title="Roles"
            link="/settings/roles"
          />
          <TransactionGridItem
            component={Package}
            title="Nations"
            link="/settings/nations"
          />
          <TransactionGridItem
            component={EarthLock}
            title="Donors"
            link="/settings/donors"
          />
          {/* </TransactionGridContainer>
        <TransactionGridContainer title="Nations & Donors"> */}
        </TransactionGridContainer>
        <TransactionGridContainer title="Currencies & Transaction Types">
          <TransactionGridItem
            component={Package}
            title="Currencies"
            link="/settings/currencies"
          />
          <TransactionGridItem
            component={EarthLock}
            title="Method Types"
            link="/settings/method-types"
          />
        </TransactionGridContainer>
      </div>
    </MainContainer>
  );
};

export default Setting;
